// @flow
import * as R from "ramda"

import { get } from "common/utils/get"
import pureTranslate from "common/services/intl/pureTranslate"
import { brandingTranslationPlaceholdersSelector } from "common/services/intl/translateSelector"
import { getLanguageNames } from "common/services/staticData"

let translationsFromGlobals = {}

// eslint-disable-next-line flowtype/no-weak-types
export function updateGlobals(translations: Object) {
  translationsFromGlobals = translations

  R.values(get(["SP_GLOBALS", "SKYPICKER_CURRENCIES"], window)).forEach(currency => {
    translationsFromGlobals[`currency.${currency.id}`] = currency.format
  })

  const langNames = getLanguageNames(window.__INITIAL_STATE__)
  Object.keys(langNames).forEach(language => {
    translationsFromGlobals[`language.${language}`] = langNames[language]
  })
}

// eslint-disable-next-line flowtype/no-weak-types
export type TranslateFunc = (string, ?Object, ?Object, ?(string[])) => string

const translate: TranslateFunc = (rawKey, values, passedOptions = {}) => {
  // Normalize args
  // ---
  const key = rawKey.toLowerCase()
  // Important when we use error codes in translation keys, eg. common.payment_error.CARD_FUNDS

  let options = { ...passedOptions }

  if (options.showKey) return key

  // TODO: Remove condition when not needed
  let data = values || {}
  const store = typeof window !== "undefined" && get("reduxStore", window)
  if (store) {
    const state = store.getState()
    if (state) {
      // $FlowIssue: FIXME
      options.translations = state.translations
    }
    data = Object.assign(data, brandingTranslationPlaceholdersSelector(state))
    // Important: Do not throw if condition doesn't pass, it's not critical to run on Node
  }

  // Deprecated behaviour, third argument was defaultShow
  if (typeof options === "string") {
    // TODO: Call cuckoo.deprecated
    const oldThirdArg = options // String, primitive value will be copied, not referenced
    options = {
      defaultShow: oldThirdArg,
    }
  }

  // $FlowIssue: FIXME
  let translations = options.translations ? options.translations : translationsFromGlobals
  // $FlowFixMe - flow does not like undef
  if (typeof NEW_TRANSLATIONS !== "undefined") {
    translations = R.mergeDeepRight(translations, NEW_TRANSLATIONS) // eslint-disable-line no-undef
  }

  const translated = pureTranslate(key, data, {
    ...options,
    translations,
    language: data.language,
  })

  return translated
}

export default translate
